import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
// import TitleComponent from '../../components/Title';
// import FormWrapperContainer from '../../components/FormWrapper';
// import ButtonComponent from '../../components/Button';

// export const Container = styled.div`
//   grid-column: 2/3;

//   @media (max-width: 769px) {
//     grid-column: 1;
//   }
// `;

// export const Title = styled(TitleComponent)``;

// export const FormWrapper = styled(FormWrapperContainer)`
//   display: flex;
//   flex-wrap: wrap;
//   margin-bottom: 50px;
// `;

// export const Button = styled(ButtonComponent)`
//   margin-left: auto;
//   margin-right: 10px;
// `;

/* .... */
export const ExternalContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TextEQ = styled.p`
  display: block;
  gap: 30px;
  font-size: 16px;
  color: ${(props) => props.theme.colors.text.blackToWhite};
  text-align: center;
  margin-bottom: 20px;

  @media (min-width: 1024px) {
    text-wrap: nowrap;
  }
`;

export const FormContent = styled.div`
  padding: 8px;
  border-radius: 5px;
  background: ${(props) => props.theme.colors.background};
  box-shadow: 0px 5px 20px
    ${(props) => transparentize(0.4, props.theme.colors.text.lightGrayToBlack)};
`;

interface loadingProps {
  inLoading?: boolean;
}

export const UnimedLogo = styled.div<loadingProps>`
  width: 100%;
  height: 70px;

  display: flex;
  justify-content: center;
  align-items: center;
  transition: 300ms;
  svg {
    height: 50px;
  }
  ${(props) =>
    props.inLoading &&
    css`
      height: 100vh;
    `}
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  column-gap: 16px;
  row-gap: 16px;
  > button {
    flex: 1;
  }
`;

export const QuestionsContainer = styled.div`
  padding: 8px;
  border-radius: 5px;
  background: ${(props) => props.theme.colors.background};
  box-shadow: 0px 5px 20px
    ${(props) => transparentize(0.4, props.theme.colors.text.lightGrayToBlack)};

  .displayNone {
    display: none !important;
  }
`;

export const Label = styled.label`
  font-family: Unimed-Sans-Book;
  font-size: 1.3rem;
  line-height: 1.7rem;
  flex: 1 0 100%;
  transition: all 300ms ease 0s;
  color: rgb(91, 92, 101);
  position: relative;
  padding-left: 10px;
`;

export const ContainerQuestions = styled.div``;
